import date from "./date.png";
import "./styles.css";

export default function Text() {
    return (
        <section className="text-section">
            <p className="text">
                Con el amor que nos une, la bendición de Dios y el apoyo de nuestros padres,
                uniremos nuestras vidas y queremos que seas parte de este nuevo capítulo.
            </p>

            <img
                src={date}
                alt="Sábado 21 de noviembre de 2026"
                className="date-image"
            />
        </section>
    );
}